import { render, staticRenderFns } from "./gradeDataTable.vue?vue&type=template&id=84199a36&scoped=true"
import script from "./gradeDataTable.vue?vue&type=script&lang=js"
export * from "./gradeDataTable.vue?vue&type=script&lang=js"
import style0 from "./gradeDataTable.vue?vue&type=style&index=0&id=84199a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84199a36",
  null
  
)

export default component.exports